import { Box, CircularProgress } from '@mui/material';
import { palette } from 'theme/palette';

const styles = {
  root: {
    position: 'relative',
  },
  top: {
    color: palette.primary.main,
    animationDuration: '1000ms',
    position: 'absolute',
    top: '50%',
    left: '50%',
  },
  bottom: {
    color: palette.primary.light,
    animationDuration: '300ms',
    position: 'absolute',
    top: '50%',
    left: '50%',
  },
};

type Props = {
  size: number;
};
/**
 * A custom circular progress bar to indicate loading.
 */
const CustomCircularProgress = ({ size }: Props) => {
  return (
    <Box data-testid="circular-progress" sx={styles.root}>
      <CircularProgress variant="determinate" value={100} sx={styles.top} size={size} thickness={4} />
      <CircularProgress variant="indeterminate" disableShrink sx={styles.bottom} size={size} thickness={4} />
    </Box>
  );
};

export default CustomCircularProgress;
